import { IRequestCourseModel } from 'models/requestCourse.model'
import api from '..'

export interface ResponseCreateRequestCourse {
  data: IRequestCourseModel[]
}

export type CreateRequestCourseParams = {
  name: string
  cost: string
  startDate: string
  endDate: string
  hour: number
  message?: string
  senceCode?: string
  urlCourse: string
}

const createRequestCourse = (values: CreateRequestCourseParams) => {
  return api.post('outsides_courses', {
    OutsidesCourse: values,
  })
}

export default createRequestCourse
